/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useContext } from 'react';

import { Divider, ShowMoreList } from '@coursera/cds-core';

import { ProfileContext } from 'bundles/account-profile/components/recruiting-profile-viewer/ProfileContextProvider';
import AdditionalInfoSection from 'bundles/account-profile/components/recruiting-profile-viewer/components/additional-info/AdditionalInfoSection';
import HighlightsSection from 'bundles/account-profile/components/recruiting-profile-viewer/components/highlights/HighlightsSection';
import WorkEligibilitySection from 'bundles/account-profile/components/recruiting-profile-viewer/components/work-eligibility/WorkEligibilitySection';
import WorkPreferencesSection from 'bundles/account-profile/components/recruiting-profile-viewer/components/work-preferences/WorkPreferencesSection';

import _t from 'i18n!nls/account-profile';

const styles = {
  showMoreList: () => css`
    background-color: var(--cds-color-white-0);
    border: 1px solid var(--cds-color-grey-50);
    border-radius: 8px;
  `,
  hideCardBorderStyling: css`
    border: none;
  `,
  divider: () => css`
    margin: 0 var(--cds-spacing-200);
  `,
};

const AdditionalInfoResponsiveComponent = () => {
  const { restrictHiringSolutions } = useContext(ProfileContext);

  return restrictHiringSolutions ? (
    <AdditionalInfoSection customCss={styles.hideCardBorderStyling} />
  ) : (
    <ShowMoreList
      css={styles.showMoreList}
      numItemsToShow={1}
      controllerProps={{
        expandedLabel: _t('Hide'),
        collapsedLabel: _t('Show more'),
        ariaLabel: _t('Show all 3 sections'),
      }}
    >
      <HighlightsSection customCss={styles.hideCardBorderStyling} />
      <div>
        <Divider color="light" css={styles.divider} />
        <WorkPreferencesSection customCss={styles.hideCardBorderStyling} />
      </div>
      <div>
        <Divider color="light" css={styles.divider} />
        <WorkEligibilitySection customCss={styles.hideCardBorderStyling} />
      </div>
      <div>
        <Divider color="light" css={styles.divider} />
        <AdditionalInfoSection customCss={styles.hideCardBorderStyling} />
      </div>
    </ShowMoreList>
  );
};

export default AdditionalInfoResponsiveComponent;
